// extracted by mini-css-extract-plugin
export default {"header":"header_header__SUJ9O","imagegallery__wrapper":"header_imagegallery__wrapper__p3a2R"};